import routeReplaceSelf from '@/utils/routeReplaceSelf';
const custApManagement = {
    path: "custApManagement",
    name: "custApManagement",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'apManagementSystem',
        icon: 'HSIconfont hs-icon-ap',
        showRealm: ['SYSTEM']
    },
    children: [
        {
            path: 'custApList',
            name: 'custApList',
            component: routeReplaceSelf(() => import('@/views/custApList/index.vue')),
            meta: { code: 'apManagementSystem:apPro' },
            children: [
                {
                    path: 'custApListDetail',
                    name: 'custApListDetail',
                    hidden: true,
                    component: () => import('@/views/custApList/components/ApDetail.vue'),
                    meta: {
                        code: 'apManagementSystem_apPro_config',
                        activeMenu: 'custApList',
                    },
                },
                {
                    path: 'custApLogDetail',
                    name: 'custApLogDetail',
                    hidden: true,
                    component: () => import('@/views/custApLogDetail'),
                    meta: {
                        code: 'apManagementSystem_apPro_log',
                        activeMenu: 'custApList',
                    },
                },
            ]
        },
        {
            path: 'custApVersion',
            name: 'custApVersion',
            component: routeReplaceSelf(() => import('@/views/custApVersion/index.vue')),
            meta: {
                code: 'apManagementSystem:version',
            },
            children: [
                {
                    path: 'custApVersionUpload',
                    name: 'custApVersionUpload',
                    hidden: true,
                    component: () => import('@/views/custApVersion/components/VersionUpload.vue'),
                    meta: {
                        code: 'apManagementSystem_version_upload',
                        activeMenu: 'custApVersion',
                    },
                },
            ]
        },
        {
            path: 'custApUpgradePlan',
            name: 'custApUpgradePlan',
            component: routeReplaceSelf(() => import('@/views/custApUpgradePlan/index.vue')),
            meta: {
                code: 'apManagementSystem:upgradePlan',
            },
            children: [
                {
                    path: 'custAddUpgradePlan',
                    name: 'custAddUpgradePlan',
                    hidden: true,
                    component: () => import('@/views/custApUpgradePlan/components/AddPlan.vue'),
                    meta: {
                        code: 'apManagementSystem_upgradePlan_create',
                        activeMenu: 'custApUpgradePlan',
                    },
                },
            ]
        },
        {
            path: 'custApApp',
            name: 'custApApp',
            component: routeReplaceSelf(() => import('@/views/custApApp/index.vue')),
            meta: { code: 'apManagementSystem:app' },
            children: [
                {
                    path: 'custAppByAp',
                    name: 'custAppByAp',
                    hidden: true,
                    component: () => import('@/views/custApApp/components/Detail.vue'),
                    meta: {
                        code: 'apManagementSystem_app_detail',
                        activeMenu: 'custApApp',
                    },
                },
            ]
        },
        {
            path: 'custApOperLog',
            name: 'custApOperLog',
            component: () => import('@/views/custApOperLog/index.vue'),
            meta: { code: 'apManagementSystem:operLog' },
        }
    ]
};
export default custApManagement;
